export const CHAT_SESSION_KEY = 'bjp_coach_session';
export const CHAT_THREADS_KEY = 'bjp_coach_threads_v2';
export const CHAT_ASSISTANT_KEY = 'bjp_coach_assistant';

export const COACH_ASSISTANTS = {
  claude: {
    name: 'Claude Coach',
    shortLabel: 'Claude',
    modelLabel: 'Sonnet 4.6',
    greeting: 'Hey there! 👋 I’m Claude Coach. Ask me about Patriots divisions, schedules, registration, coaches, or events.',
  },
  chatgpt: {
    name: 'ChatGPT Coach',
    shortLabel: 'ChatGPT',
    modelLabel: 'GPT-5.4 mini',
    greeting: 'Hi! 👋 I’m ChatGPT Coach. I’m ready to help with Patriots schedules, registration, teams, and community events.',
  },
};

export const createInitialThreads = () => Object.fromEntries(
  Object.entries(COACH_ASSISTANTS).map(([key, assistant]) => [
    key,
    [{ role: 'assistant', content: assistant.greeting }],
  ]),
);

export const getSessionId = () => {
  let sessionId = localStorage.getItem(CHAT_SESSION_KEY);
  if (!sessionId) {
    sessionId = window.crypto?.randomUUID?.()
      || `web-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
    localStorage.setItem(CHAT_SESSION_KEY, sessionId);
  }
  return sessionId;
};

export const loadAssistant = () => {
  const saved = localStorage.getItem(CHAT_ASSISTANT_KEY);
  return saved && COACH_ASSISTANTS[saved] ? saved : 'claude';
};

export const loadThreads = () => {
  const defaults = createInitialThreads();
  try {
    const saved = JSON.parse(localStorage.getItem(CHAT_THREADS_KEY) || '{}');
    return Object.fromEntries(Object.keys(COACH_ASSISTANTS).map((key) => [
      key,
      Array.isArray(saved[key]) && saved[key].length ? saved[key] : defaults[key],
    ]));
  } catch {
    return defaults;
  }
};